import { Spinner } from '@common/components';
import { PageContext, RoutingData } from '@common/components/PageContext';
import {
  SpaEntityContainer,
  SpaEntityContainerProps,
  parseSpaEntityData,
} from '@common/components/SpaEntity/SpaEntityContainer';
import { Routes } from '@common/constants';
import { useLabels } from '@features/Menu/useLabels';
import { useGetSpaSettings, useGetSpaTreatment } from '@features/spa/hooks';
import { useTranslations } from '@lang';
import { mergeCrossSellWithUpsell, parseDateToString } from '@utils/helpers';
import Cookie from 'js-cookie';
import { FC } from 'react';
import { SpaTreatmentConfigWizard } from '../SpaTreatmentConfigWizard/SpaTreatmentConfigWizard';

export const SpaTreatmentContainer: FC<SpaEntityContainerProps> = ({
  id,
  bookingStep,
  property,
  language,
  basketGuests,
  basketDetails,
  updateBasket,
  createBasket,
  signIn,
  upSellName,
  defaultTitle,
  entityType,
  journeyParams,
}) => {
  const { t } = useTranslations();
  const labels = useLabels();
  const parentPageName = t('spa.spaTreatment');
  const { data: spaEntity, isFetching } = useGetSpaTreatment(
    property.id,
    language,
    id,
    parseDateToString(journeyParams.spaDate)
  );
  const { data: spaSettings } = useGetSpaSettings(property.id);
  const { termsAndConditions = '' } = spaSettings || {};
  const routingData: RoutingData = {
    message: t('common.backToModuleRoot', {
      entity: labels?.treatments || t('app.spaTreatments'),
    }),
    href: Routes.SPA_TREATMENT_LIST,
  };

  const mergedItems = mergeCrossSellWithUpsell(
    spaEntity?.upSell,
    upSellName,
    spaEntity?.crossSellObjects
  );

  const handleBasketUpdate = (data) => {
    if (spaEntity) {
      const parsedEntity = parseSpaEntityData(data, spaEntity, entityType);

      const basketId = Cookie.get('basketId');

      if (basketId) {
        return updateBasket(property.id, basketId, language, {
          items: [...basketDetails.items, parsedEntity],
        });
      }
      return createBasket(property.id, language, {
        items: [parsedEntity],
      });
    }
  };

  if (!spaEntity) {
    return <Spinner showDelayMessage isActive={isFetching} />;
  }

  return (
    <PageContext value={{ parentPageName, routingData }}>
      <SpaEntityContainer
        spaEntity={spaEntity}
        spaTermsAndConditions={termsAndConditions}
        bookingStep={bookingStep}
        property={property}
        language={language}
        basketGuests={basketGuests}
        basketDetails={basketDetails}
        signIn={signIn}
        defaultTitle={defaultTitle}
        SpaEntityConfigurationWizard={SpaTreatmentConfigWizard}
        mergedItems={mergedItems}
        handleBasketUpdate={handleBasketUpdate}
      />
    </PageContext>
  );
};
